import { SharingTipAction } from '../../types/SharingTipAction';
import { SharingTipId } from '../../types/sharingTipId';
import { assertNever } from 'owa-assert';

export function getSharingTipActions(sharingTipId: SharingTipId): SharingTipAction[] {
    switch (sharingTipId) {
        case SharingTipId.noPermissionToShare:
        case SharingTipId.noPermissionToShareExternally:
        case SharingTipId.getSharingInfoFailed:
            return [SharingTipAction.ignore];
        case SharingTipId.externalRecipientCSL:
        case SharingTipId.noPermissionSet:
        case SharingTipId.sharingWithLargeDL:
            return [SharingTipAction.ignore, SharingTipAction.changePermission];
        case SharingTipId.linkWillExpire:
        case SharingTipId.linkHasExpired:
            return [SharingTipAction.ignore, SharingTipAction.refreshExpiration];
        default:
            return assertNever(sharingTipId);
    }
}
